import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConfigurationAudit } from '../../../actions/configurations';
export const useConfigurationAudit = ({ isOpen, tenantId, configKeyname })=>{
    const [pageNumber, setPageNumber] = useState(1);
    const dispatch = useDispatch();
    // Get audit history from Redux store
    const configurationAuditData = useSelector((state)=>state.configurations.configurationAuditHistory);
    // Fetch audit history when drawer opens
    useEffect(()=>{
        if (isOpen && tenantId && configKeyname) {
            dispatch(fetchConfigurationAudit({
                tenantId,
                pageNumber: pageNumber || 1,
                pageSize: 10,
                searchKey: configKeyname
            }));
        }
    }, [
        isOpen,
        tenantId,
        configKeyname,
        pageNumber,
        dispatch
    ]);
    // Handle page change for pagination of audit data
    const handlePageChange = (newPageNumber)=>{
        if (newPageNumber !== pageNumber) {
            setPageNumber(newPageNumber);
        }
    };
    return {
        configurationAuditData,
        handlePageChange,
        pageNumber
    };
};
